import { createFileRoute } from '@tanstack/react-router';
import { initializeModuleState } from 'lib/moduleStateUtils';

/**
 * Saved Searches Route (Dynamic Module)
 * Handles both /pc/savedsearches and /eb/savedsearches via :module param
 *
 * Authentication is handled by the parent _protected layout route.
 */
export const Route = createFileRoute('/_protected/$module/savedsearches')({
  beforeLoad: async (ctx) => {
    // Initialize module state based on URL parameter before component loads
    initializeModuleState(undefined, ctx.params.module);
    // authGuard removed - parent _protected handles auth
  },
});
